// 可以通过 svgo 手动对所有的svg资源进行优化
import "./index.scss";
import { Component, Prop, Vue } from "vue-property-decorator";

// 异步加载
// eslint-disable-next-line no-unused-expressions
import("./svg/async-import");

@Component
export default class IconSvg extends Vue {
  @Prop({
    type: String,
    required: true,
  })
  readonly iconClass!: string;

  @Prop(Number) readonly size!: number;

  get iconName(): string {
    return `#icon-${this.iconClass}`;
  }

  private render() {
    const svgProps = {
      ...this.$data,
      staticClass: "IconSvg",
      on: {
        ...this.$listeners,
      },
      style: {
        fontSize: `${this.size}px`,
      },
    };

    return (
      <svg {...svgProps}>
        <use xlinkHref={this.iconName} />
      </svg>
    );
  }
}
